
import { Outlet,useNavigate } from "react-router-dom";
import { functionService } from "./lib/functions";

import './App.scss';

import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import Sidemenu from "./components/sidemenu";
function App() {
  let navigate = useNavigate();
  
  useEffect(() => {
    const getToken = localStorage.getItem("jwtToken");
    
    if (getToken) {
      functionService.post(
        `auth/session`,
        {token : getToken}
      ).then(authResponse => {
        console.log('Session check:', authResponse.status)
        if(!authResponse.status && authResponse.error.response.status===401){
          localStorage.removeItem("jwtToken");
          navigate(`/login`, { replace: true });
        }
      });
    } else {
      navigate(`/login`, { replace: true });
    }
  }, []);

  return (
    <div className="App">
      <Outlet />
    </div>
  );
}

export default App;
